import authRoles from '../auth/authRoles';

const navigationConfig = [
  {
    id: 'curriculum',
    title: 'Curriculum',
    subtitle: 'View lesson content',
    type: 'group',
    translate: 'Curriculum',
    children: [
      {
        id: 'project-component',
        title: 'Projects',
        translate: 'Projects',
        type: 'item',
        icon: 'base-icons:home',
        url: 'projects',
        disabled: false
      },
      {
        id: 'course-component',
        title: 'Course',
        translate: 'Course',
        type: 'item',
        icon: 'heroicons-outline:view-grid',
        url: 'courses',
        disabled: true
      },
      {
        id: 'lesson-component',
        title: 'Lesson',
        translate: 'Lesson',
        type: 'item',
        icon: 'heroicons-outline:cube',
        url: 'lessons',
        disabled: true
      },
      {
        id: 'section-component',
        title: 'Section',
        translate: 'Section',
        type: 'item',
        icon: 'heroicons-outline:folder',
        url: 'sections',
        disabled: true
      },
      {
        id: 'page-component',
        title: 'Page',
        translate: 'Page',
        type: 'item',
        icon: 'heroicons-outline:document-text',
        url: 'pages',
        disabled: true
      }
    ]
  },
  {
    id: 'templates',
    title: 'Templates',
    subtitle: 'View template content',
    type: 'group',
    auth: authRoles.leads,
    translate: 'Templates',
    children: [
      {
        id: 'templates-component',
        title: 'Templates',
        type: 'item',
        auth: authRoles.leads,
        url: 'templates',
        icon: 'heroicons-outline:template',
        disabled: false
      }
    ]
  },
  // {
  //   id: "account",
  //   title: "Account",
  //   subtitle: "View user account information",
  //   type: "group",
  //   translate: "Account",
  //   children: [
  //     {
  //       id: "settings-component",
  //       title: "Settings",
  //       translate: "Settings",
  //       type: "item",
  //       icon: "heroicons-outline:cog",
  //       url: "settings",
  //       disabled: false,
  //     },
  //   ],
  // },
  {
    id: 'admin',
    title: 'System Admin',
    subtitle: 'Update system settings',
    type: 'group',
    auth: authRoles.leads,
    translate: 'Admin',
    children: [
      {
        id: 'users-component',
        title: 'Users',
        type: 'item',
        auth: authRoles.leads,
        url: 'users',
        icon: 'heroicons-outline:user-group',
        disabled: false
      },
      {
        id: 'organizations-component',
        title: 'Organizations',
        type: 'item',
        auth: authRoles.leads,
        url: 'organizations',
        icon: 'heroicons-outline:office-building',
        disabled: false
      },
      {
        id: 'reviews-component',
        title: 'Reviews',
        type: 'item',
        auth: authRoles.leads,
        url: 'reviews',
        icon: 'heroicons-outline:calendar',
        disabled: false
      }
    ]
  }
];

export default navigationConfig;
